import { render, staticRenderFns } from "./LogoutModal.vue?vue&type=template&id=bbf817a0"
import script from "./LogoutModal.vue?vue&type=script&lang=js"
export * from "./LogoutModal.vue?vue&type=script&lang=js"
import style0 from "./LogoutModal.vue?vue&type=style&index=0&id=bbf817a0&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports